/**
 * POSTHOG_VISIBLE is a constant object to be used as a data attribute for
 * elements that should be visible in PostHog session recordings.
 *
 * @example
 * <div {...POSTHOG_VISIBLE}></div> // This div's inner text will be visible in PostHog session recordings.
 */
export const POSTHOG_VISIBLE = {
  "data-ph-visible": "true"
};

/** Used in PostHog config maskTextFn. Must match the data attribute key in POSTHOG_VISIBLE.
 *
 * Note: JS converts data attributes from kebab-case to camelCase, so "data-ph-visible" becomes "phVisible".
 */
export const POSTHOG_VISIBLE_KEY = "phVisible";

/** Class-name for elements that should not be captured in PostHog session recordings or in PostHog auto-capture */
export const PH_NO_CAPTURE = "ph-no-capture";
